// extracted by mini-css-extract-plugin
export default {"alertHeader":"App_alertHeader__2L24Z","mainContent":"App_mainContent__mD5IX"};